var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40434 31.3603C-3.4565 53.2324 9.52339 75.7142 31.3957 81.5747C53.2676 87.4354 75.7495 74.4555 81.6101 52.5834C87.4707 30.7113 74.4908 8.22947 52.6188 2.369C30.7466 -3.49176 8.26473 9.48813 2.40434 31.3603Z",
    stroke: "url(#paint0_linear_2097_799)",
    strokeWidth: 0.454737,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2097_799",
    x1: 62.5071,
    y1: 77.4789,
    x2: 21.5071,
    y2: 6.4648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightCircle);
export default __webpack_public_path__ + "static/media/light-circle.a390d3a09a5ebff25a461e9a6fd6e397.svg";
export { ForwardRef as ReactComponent };